import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Box, Flex, Text } from '@radix-ui/themes';
import { useMediaState } from '@vidstack/react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/SmartPlayer.module.css';

export const SmartPlayerError = () => {
    const { t } = useTranslation('smartPlayer');
    const error = useMediaState('error');
    if (!error) return null;

    return (
        <Flex
            align='center'
            justify='center'
            direction='column'
            gap='3'
            className={styles.errorOverlay}
        >
            <Box
                style={{
                    backgroundColor: 'var(--red-3)',
                    padding: 'var(--space-3)',
                    borderRadius: 'var(--radius-full)',
                }}
            >
                <ExclamationTriangleIcon
                    width='32'
                    height='32'
                    color='var(--red-9)'
                />
            </Box>
            <Text size='5' weight='bold'>
                {t('error.title')}
            </Text>
            <Text
                size='3'
                style={{ color: 'var(--gray-11)', maxWidth: '400px' }}
            >
                {error.message || t('error.default_message')}
            </Text>
            {error.code && (
                <Text
                    size='1'
                    style={{
                        color: 'var(--gray-9)',
                        marginTop: 'var(--space-2)',
                        fontFamily: 'var(--font-mono)',
                    }}
                >
                    {t('error.code', { code: error.code })}
                </Text>
            )}
        </Flex>
    );
};
